module.exports = __webpack_public_path__ + "static/img/logo-icon.686cf26e.png";